var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-2 dense",style:({
		opacity: (_vm.quantity > 0 ? '1' : '0.4'),
		'min-height': 0
	})},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
	var on = ref.on;
return [_c('div',_vm._g({},on),[_c('v-img',{staticClass:"rounded",attrs:{"max-width":32,"src":_vm.imageLinks.iconBuff(_vm.buff.icon)}}),_c('div',[_vm._v(_vm._s(_vm.quantity))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.buff.type))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }